// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1V1V7","detailsBorder":"styles_detailsBorder__3WMAt"};